// Haptic feedback utility for mobile devices
// Uses the Vibration API where supported

/**
 * Trigger haptic feedback
 * @param {'light' | 'medium' | 'heavy' | 'success' | 'error' | 'warning'} type
 */
export function haptic(type = 'light') {
  if (!navigator.vibrate) return

  const patterns = {
    light: 10,
    medium: 25,
    heavy: 50,
    success: [10, 50, 10],      // Quick double tap
    error: [50, 30, 50, 30, 50], // Three pulses
    warning: [30, 50, 30],       // Two pulses
    selection: 5,                // Very light
    impact: 40                   // Single solid tap
  }

  const pattern = patterns[type] || patterns.light
  
  try {
    navigator.vibrate(pattern)
  } catch (e) {
    // Silently fail if vibration not supported
  }
}

/**
 * Check if haptics are supported
 */
export function supportsHaptics() {
  return 'vibrate' in navigator
}

/**
 * Play haptic on element interaction (for buttons, etc.)
 * Use as onClick handler wrapper
 */
export function withHaptic(callback, type = 'light') {
  return (...args) => {
    haptic(type)
    return callback?.(...args)
  }
}
